type StationsErrorProps = {
  title?: string;
  message?: string;
  minHeight?: string;
};

export function StationsError({
  title = 'Dados não disponíveis no momento',
  message = 'Não foi possível carregar as informações agora. Tente novamente em instantes.',
  minHeight = '384px',
}: StationsErrorProps) {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center my-6 p-4 w-100"
      style={{
        minHeight: minHeight,
      }}
      role="status"
      aria-live="polite"
    >
      <svg
        width="120"
        height="120"
        viewBox="0 0 120 120"
        aria-hidden="true"
        className="mb-3"
      >
        {/* nuvem */}
        <g opacity="1">
          <path
            d="M48 78H36a20 20 0 1 1 5.2-39.3A24 24 0 0 1 81 30 a22 22 0 0 1 21.4 18.6A16 16 0 0 1 92 78H48z"
            fill="#e9ecef"
            stroke="#ced4da"
            strokeWidth="2"
            strokeLinejoin="round"
            strokeLinecap="round"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </g>

        {/* gotas animadas */}
        <g className="rain">
          <path
            d="M48 85c0 3-2 6-4 6s-4-3-4-6 4-8 4-8 4 5 4 8z"
            fill="#74c0fc"
          />
          <path
            d="M68 88c0 3-2 6-4 6s-4-3-4-6 4-8 4-8 4 5 4 8z"
            fill="#74c0fc"
          />
          <path
            d="M88 85c0 3-2 6-4 6s-4-3-4-6 4-8 4-8 4 5 4 8z"
            fill="#74c0fc"
          />
        </g>

        {/* ícone de aviso */}
        <g>
          <circle
            cx="93"
            cy="33"
            r="14"
            fill="#fff5f5"
            stroke="#ffa8a8"
            strokeWidth="2"
          />
          <path d="M93 24l8 14H85l8-14z" fill="#fa5252" />
          <rect x="92" y="28" width="2" height="5" rx="1" fill="white" />
          <rect x="92" y="34" width="2" height="2" rx="1" fill="white" />
        </g>

        <style>
          {`
            .rain path {
              animation: drop 1.8s ease-in infinite;
              transform-origin: center;
            }
            .rain path:nth-child(2){ animation-delay: .25s }
            .rain path:nth-child(3){ animation-delay: .5s }
            @keyframes drop {
              0%   { transform: translateY(0); opacity: .9; }
              70%  { opacity: .9; }
              100% { transform: translateY(16px); opacity: 0; }
            }
          `}
        </style>
      </svg>

      <h5 className="mb-2 fw-semibold" style={{ color: '#1f5a92' }}>
        {title}
      </h5>
      <p className="text-muted mb-3">{message}</p>
    </div>
  );
}
